import React, { useState } from "react";
import { Button, Row, Card, Col } from "react-bootstrap";

import TextEditor from "../components/TextEditor";
import { consult, transfer } from "../data/nurseForms";
import { MdOutlineTransferWithinAStation } from "react-icons/md";
import {
  codeBlue,
  criticalResultAlert,
  fallingEventContent,
  nursingCarePlan,
} from "../data/nurseForms";
import { FaPersonFalling } from "react-icons/fa6";
import { MdFormatListBulleted } from "react-icons/md";
import { TbActivityHeartbeat } from "react-icons/tb";
import { FaRemoveFormat } from "react-icons/fa";
import { IoNotifications } from "react-icons/io5";

const Test = () => {
  const [r, setR] = useState("");
  const handleClear = () => {
    if (window.confirm("You will delete all text. Are you sure?")) {
      setR("");
    }
  };
  return (
    <>
      <TextEditor text={r} setText={setR} rtl={true} />
      <p>{r}</p>
      <Row className="g-3 text-center text-primary my-2">
        <Col
          className="my-2"
          md={3}
          onClick={() => setR((prev) => prev + consult)}
        >
          <Card className="h-100 shadow-sm border border-primary">
            <Card.Body>
              <Card.Text>
                <MdFormatListBulleted /> Add Consultation Form{" "}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col
          className="my-2"
          md={3}
          onClick={() => setR((prev) => prev + transfer)}
        >
          <Card className="h-100 shadow-sm border border-primary ">
            <Card.Body>
              <Card.Text>
                <MdOutlineTransferWithinAStation /> Add Transfer Form{" "}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col className="my-2" md={3} onClick={handleClear}>
          <Card className="h-100 shadow-sm border border-danger text-danger">
            <Card.Body>
              <Card.Text>
                <FaRemoveFormat /> Clear{" "}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row dir="rtl" className="g-3 text-center text-primary my-2">
        <Col
          className="my-2"
          md={3}
          onClick={() => setR((prev) => prev + nursingCarePlan)}
        >
          <Card className="h-100 shadow-sm border border-primary">
            <Card.Body>
              <Card.Text>
                <MdFormatListBulleted /> إضافة نموذج خطة الرعاية التمريضية.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col
          className="my-2"
          md={3}
          onClick={() => setR((prev) => prev + criticalResultAlert)}
        >
          <Card className="h-100 shadow-sm border border-primary ">
            <Card.Body>
              <Card.Text>
                <IoNotifications /> إضافة نموذج الإبلاغ عن النتائج الحرجة
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col
          className="my-2"
          md={3}
          onClick={() => setR((prev) => prev + fallingEventContent)}
        >
          <Card className="h-100 shadow-sm border border-primary ">
            <Card.Body>
              <Card.Text>
                <FaPersonFalling /> إضافة نموذج تقييم سقوط مريض
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col
          className="my-2"
          md={3}
          onClick={() => setR((prev) => prev + codeBlue)}
        >
          <Card className="h-100 shadow-sm border border-primary ">
            <Card.Body>
              <Card.Text>
                <TbActivityHeartbeat /> إضافة نموذج الإنعاش القلبي الرئوي
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col className="my-2" md={3} onClick={handleClear}>
          <Card className="h-100 shadow-sm border border-danger text-danger">
            <Card.Body>
              <Card.Text>
                <FaRemoveFormat /> امسح الكل
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Test;
